import {
  APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_BEGIN,
  APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_SUCCESS,
  APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_FAILURE,
  APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateLocalizationKeyValue(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_BEGIN,
    });
    const { projectId, uuid, key } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}localization/${uuid}/updateKeyandValue/${key}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_SUCCESS,
              data: res.data,
              uuid: args.uuid,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateLocalizationKeyValueError() {
  return {
    type: APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_BEGIN:
      return {
        ...state,
        updateLocalizationKeyValuePending: true,
        updateLocalizationKeyValueError: null,
      };

    case APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_SUCCESS:
      const localization = state.localization;
      const index = localization.findIndex((local) => local.uuid === action.uuid);
      localization[index] = action.data;
      return {
        ...state,
        updateLocalizationKeyValuePending: false,
        updateLocalizationKeyValueError: null,
        localization,
      };

    case APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_FAILURE:
      return {
        ...state,
        updateLocalizationKeyValuePending: false,
        updateLocalizationKeyValueError: action.data.error,
      };

    case APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR:
      return {
        ...state,
        updateLocalizationKeyValueError: null,
      };

    default:
      return state;
  }
}
